export default __webpack_public_path__ + "static/media/angle-right.0c6b4ea2.svg";